import { render, staticRenderFns } from "./LoginCarImage.vue?vue&type=template&id=34244f25&"
import script from "./LoginCarImage.vue?vue&type=script&lang=js&"
export * from "./LoginCarImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QImg} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QImg})
